import BookingTypeHome from "../../../components/business/bookingType/bookingTypeHome"; 
import Portal from "../portal";

const BookingTypeHomePortal = (props) => {
  return (
    <Portal
      TabComponent={BookingTypeHome}
      title={"BookingTypes"}
      props={props}
    />
  );
};
export default BookingTypeHomePortal;
